export const names = [
  'Tixyel',
  'awigui',
  'kurao_w',
  'Urie_s2',
  'itzzcatt',
  'BeniArts',
  'mynnyori',
  'DexPixel',
  'Cupidiko',
  'starkuss_',
  'catsember',
  'shy_madeit',
  'SpookySony',
  'nanagadesign',
];
